import * as c from './constants';
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import moment from 'moment';

//ReferenceDate: moment().add(1,'days').format("YYYY-MM-DD")

const QuoteFlowData = ( state = {}, action) => {
  switch (action.type){
    case c.SET_QUOTEFLOW_DATA:
      return {
        ...action.payload,
        availabilityDates: [],
        servicabilityParams: [ "originZipCode", "originCity", "destinationZipCode", "destinationCity", "ReferenceDate" ],
        queryStringKeys: ["ReturnUUID", "NSContactUUID"],
        Steps: [
            { ...action.payload.Steps.slice(0,1)[0], active: true  },
            ...action.payload.Steps.slice(1)
          ]
      }
      break;
    case c.SET_COMPLETE_STEPS:
      return {
        ...state,
        Steps: [ ...state.Steps.map( (step, index) => {
            return {
              ...step,
              completed: action.completedSteps.includes(index),
              active: action.activeSteps.includes(index)
            };
        })]
      }
      break;
    case c.SET_AVAILABILITY_DATES:
        let availabilityDates = [];
        action.availabilityDates.map( (availabilityDate) => {
          if(!availabilityDate.IsAvailable || moment(availabilityDate.Date).format('dddd') === "Sunday"){
              availabilityDates.push(moment(availabilityDate.Date));
          }
        });
      return {
        ...state,
        availabilityDates: availabilityDates
      }
      break;
    case c.SET_ADDRESS_OPTIONS:
      return {
        ...state,
        Steps: [ ...state.Steps.map( (step, index) => {
            let containsOriginZipCode = false;
            step.Input.map( (input) => {
              if( input.Name && input.Name.toLowerCase() === 'originzipcode' ) {
                containsOriginZipCode = true;
              }
            })
            if( containsOriginZipCode ){
              return {
                ...step,
                Input: [ ...step.Input.map( (input, index) => {
                    if(input.Name === action.addressName){
                      return {
                        ...input,
                        Value: populateAddressOptions(action.addressOptions, action.addressName, action.skipAddressProcessing)
                      }
                    } else {
                      return input;
                    }
                  })]
              }
            } else {
              return step;
            }
        })]
      }
      return state;
      break;
    case c.SET_ERROR_MODAL:
      return {
        ...state,
        errorModal: action.errorModal
      }
      break;
    default:
      return state;
  }
}


const populateAddressOptions = (addresses, addressName, skipAddressProcessing) => {
  let addressOptions = [];
  if( skipAddressProcessing ) {
    addressOptions = addresses;
  } else {
    if (addresses.length > 1){
      addressOptions = [{ "Label": "------", "Value": null, "Selected": true }, ...addresses ]
    } else {
      addresses.map( (address, index) => {
        let cityObject = JSON.parse(address.Value);
        if(index === 0 && cityObject.City) {
          addressOptions.push({
            ...address,
            "Selected": true
          })
        }
      });
    }
  }
  return addressOptions;
}

export default combineReducers({
  QuoteFlowData,
  form
});
